import { useTranslation } from 'react-i18next'

import { DATE_FULL_FORMAT_FROM_TIME } from '../../../../../constants/date'
import { useDateLocale, useTimeZone } from '../../../../../hooks'
import { formatDate } from '../../../../Table'
import Text from '../../../../Text'

function TrackingItemDate({ current, date }) {
  const { t } = useTranslation()

  const timezone = useTimeZone()
  const locale = useDateLocale()

  const itemDate = formatDate({
    date,
    dateFormat: DATE_FULL_FORMAT_FROM_TIME,
    locale,
    timezone,
    useTodayFormat: false,
  })

  return current || date ? (
    <Text isSecondary>
      {current ? t('EpostStatusTimeline.TrackingNowTextkey') : itemDate}
    </Text>
  ) : null
}

export default TrackingItemDate
